import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q3 = ({ history }) => {
  const { t } = useTranslation();
  const Q3Options = useMemo(
    () => [
      {
        id: 0,
        name: t('peace_of_mind'),
        value: 'peace_of_mind',
      },
      {
        id: 1,
        name: t('ensure_they_safe'),
        value: 'ensure_they_safe',
      },
      {
        id: 2,
        name: t('they_honest'),
        value: 'they_honest',
      },
      {
        id: 3,
        name: t('case_of_emergency'),
        value: 'case_of_emergency',
      },
      {
        id: 4,
        name: t('all_the_above'),
        value: 'all_the_above',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question3')}
      options={Q3Options}
      nextUrl="q4"
      screenName="q3"
    />
  );
};

export default Q3;
